import { render } from "./FlowBranchReorderModal.vue?vue&type=template&id=052b94a4&scoped=true"
import script from "./FlowBranchReorderModal.vue?vue&type=script&lang=ts"
export * from "./FlowBranchReorderModal.vue?vue&type=script&lang=ts"

import "./FlowBranchReorderModal.vue?vue&type=style&index=0&id=052b94a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-052b94a4"

export default script